// extracted by mini-css-extract-plugin
module.exports = {"paperRoot":"BaseDialog_paperRoot__3bO3l","backdrop":"BaseDialog_backdrop__2vEd4"};